/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer?: string;
};

type HookTuple = [
  response: vp.AutoBalanceTransferReportResponse | undefined,
  fetchData: (transactionID: string) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchAutoBalanceTransferReport: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<string>();
  const [response, setResponse] = useState<vp.AutoBalanceTransferReportResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: string) => {
      setDataFetchingInfo(true, 'processing', 'fullScreen', true);

      const res = await api.fetchAutoBalanceTransferReport({ TransactionID: requestParams }, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'processing', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: string) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchAutoBalanceTransferReport);
